import { Box, Card, CardContent, Fab, Typography } from '@mui/material';
import { Delete, Layers, Tv } from '@mui/icons-material';
import React, { FC } from 'react';
import { TagType } from '../../../__generated__/queries-web';
import { TAG_ITEM_DATA_TESTID } from './constants';
import { Thumbnail } from './Thumbnail';
import { useStyles } from './styles';

interface TagItemProps {
  onDelete?: { (item: Record<'id' | 'title', string>): void };
  id: string;
  title: string;
  type: TagType | 'Event' | 'Guide';
}

const TeleIcon = ({
  label,
  iconComponent,
}: {
  label: string;
  iconComponent: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        width: 65,
        height: 65,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          minWidth: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#ffebee',
          color: 'error.dark',
        }}
      >
        {iconComponent}
      </Box>
      <Typography sx={{ fontSize: 10, lineHeight: 1 }}>{label}</Typography>
    </Box>
  );
};

const TagItem: FC<TagItemProps> = ({ id, onDelete, title, type }) => {
  const classes = useStyles();

  return (
    <Card className={classes.wrapper} data-testid={TAG_ITEM_DATA_TESTID}>
      {(() => {
        if (type === TagType.TvProgram) {
          return (
            <TeleIcon
              label="Program TV"
              iconComponent={<Tv sx={{ fontSize: 16 }} />}
            />
          );
        }
        if (type === TagType.TvCollection) {
          return (
            <TeleIcon
              label="Collection TV"
              iconComponent={<Layers sx={{ fontSize: 16 }} />}
            />
          );
        }
        return <Thumbnail id={id} type={type} />;
      })()}

      <CardContent className={classes.innerWrapper}>
        <Typography className={classes.title} component="h6">
          {title}
        </Typography>
      </CardContent>

      {onDelete && (
        <Fab
          className={classes.deleteIcon}
          color="primary"
          onClick={() => {
            onDelete({ id, title });
          }}
          size="small"
        >
          <Delete />
        </Fab>
      )}
    </Card>
  );
};

export { TagItem };
